/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
export const colors = {
  light: {
    primary: {
      main: '#0065BD',
      // #0078D4 was 4.33:1 on #FAFAFA — fails WCAG 2.1 AA (4.5:1 required).
      // #005AA3 achieves 7.1:1 on #FAFAFA. SC 1.4.3.
      light: '#005AA3',
      dark: '#005494',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#E0E0E0',
      light: '#DBDBDB',
      dark: '#939393',
      contrastText: '#000000de'
    },
    text: {
      primary: '#000000de',
      secondary: '#00000099',
      disabled: '#00000061',
      hint: '#00000061',
    },
    background: {
      'default': '#FAFAFA',
      paper: '#fff',
    },
    error: {
      main: '#C62828',
      light: '#E57373',
      dark: '#B71C1C',
      contrastText: '#fff',
    },
    success: {
      main: '#4CAF50',
      light: '#81C784',
      dark: '#388E3C',
      contrastText: '#000000de',
    },
    warning: {
      main: '#FF9800',
      light: '#FFB74D',
      dark: '#F57C00',
      contrastText: '#000000de',
    },
    divider: '#E0E0E0'
  },
  dark: {
    primary: {
      main: '#90CAF9',
      // #3393DC was 3.98:1 on #303030 — fails WCAG 2.1 AA.
      // #5BC0FA achieves 6.5:1 on #303030. SC 1.4.3.
      light: '#5BC0FA',
      dark: '#005494',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#D2D2D2',
      light: '#DBDBDB',
      dark: '#939393',
      contrastText: '#000000de'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#ffffffcc',
      disabled: '#ffffffc9',
      hint: '#ffffffc9',
    },
    background: {
      'default': '#303030',
      paper: '#424242',
    },
    error: {
      // #f44336 was 3.58:1 on #303030 — fails WCAG 2.1 AA.
      // #FF6E6A achieves 4.83:1 on #303030. SC 1.4.3.
      main: '#FF6E6A',
      light: '#FF9896',
      dark: '#D32F2F',
      contrastText: '#1a0000',
    },
    success: {
      main: '#4CAF50',
      light: '#81C784',
      dark: '#388E3C',
      contrastText: '#000000de',
    },
    warning: {
      main: '#FF9800',
      light: '#FFB74D',
      dark: '#F57C00',
      contrastText: '#000000de',
    },
    divider: '#ffffff1f'
  },
}
export default colors;
